module.exports = __webpack_public_path__ + "img/bg_tab.5faeb53c.png";